
























































import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
import { Vue, Prop, Component } from "vue-property-decorator";

interface Target {
  result: string;
  output: string;
}

interface Event {
  target: Target;
}

const isEvent = function (e): e is Event {
  return e && e.target !== null && e.target !== undefined && e.target.result;
};

@Component
export default class SingleImage extends Vue {
  @Prop(String) readonly width!: string;
  @Prop(String) readonly height!: string;
  @Prop(String) readonly label!: string;
  @Prop(String) readonly id!: string;
  @Prop(String) readonly url!: string;
  @Prop(Boolean) readonly hasError!: boolean;

  image: string = "";
  invalid: Boolean = false;
  public onChange(e) {
    const file = e.target.files[0];
    if (!e.target.files[0].type.match("image.*")) {
      this.invalid = true;
      this.$toasted.error("Invalid File format");
      return;
    }
    if (this.validateFileSize(file)) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (isEvent(e)) {
          const image = e.target.result;
          this.image = image;
          this.$emit("change", image);
        }
      };
      reader.readAsDataURL(file);
    }
  }

  private validateFileSize(file) {
    var FileSize = file.size / 1024 / 1024; // in MB
    if (FileSize > 2) {
      this.$toasted.info("File size exceeds 2 MB..please select different file.");
      return false;
    } else {
      return true;
    }
  }

  private reset() {
    this.image = "";
  }
}
